import { useEffect } from 'react';
import PropTypes from 'prop-types';
import updateEstimateURL from '../helpers/updateEstimateURL';

const AddEstimateLoader = ({ addDesign }) => {
  useEffect(() => {
    addDesign().then((design) => {
      updateEstimateURL(design);
    });
  }, []);

  return null;
};

AddEstimateLoader.propTypes = {
  addDesign: PropTypes.func.isRequired,
};

export default AddEstimateLoader;
